

import { Component, Vue, Watch, Prop, ProvideReactive, InjectReactive, Inject, Provide } from "vue-property-decorator"
import { namespace, Getter, Action, Mutation } from "vuex-class"

import "@/scripts/array-operations"
import Guid from "@/scripts/guid"

import cloneDeep from "lodash/cloneDeep"

import { MapProvider } from "@/services/mapProvider"
import { FieldInstance, Case, Field, DataDefinition } from "@/types"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import TextAreaExpand from "../Fields/TextAreaExpand.vue"
import DataForm from "../Config/DataForm.vue"
import MapDisplay from "@/components/Controls/Map.vue"
import { BModal } from "bootstrap-vue"

import vSelect from "vue-select"
import SkeletonLoader from "@/components/SkeletonLoader.vue"

import { RecordNameSettings } from "@/types/recordNameSettings"
import apiRecordNameSettings from "@/services/api_RecordNameSettings"

import { CaseNameSettings } from "@/types/caseNameSettings"
import apiCaseNameSettings from "@/services/api_CaseNameSettings"

import api from "@/services/api"
const caseStore = namespace("cases")
const setup = namespace("setup")

@Component({
	name: "DataDetailsModal",
	components: {
		"text-area-expand": TextAreaExpand,
		"v-select": vSelect,
		"data-form": DataForm,
		"scrollbar": VuePerfectScrollbar,
		"skeleton": SkeletonLoader,
		"map-display": MapDisplay
	}
})
export default class DataDetailsModal extends Vue {
	$refs!: {
		dataDetailsModal: BModal
	}

	@Inject({ from: "mapProvider", default: () => null }) parentMapProvider!: MapProvider;
	@Provide("mapProvider") mapProvider: MapProvider = new MapProvider();

	@caseStore.Getter("getCurrentCase")
	public currentCase: any;

	@setup.Action public definitionGetFromSource!: (arg0: string) => Promise<DataDefinition>;

	@Prop({ type: Boolean, default: false })
	generateItemLabels!: boolean;

	@Prop({ type: Boolean, default: false })
	allowMap!: boolean;

	showOtherCases: boolean = true;
	showDataForm: boolean = false;

	@Getter("getCaseName") getCaseName!: string;
	@Getter("getRecordName") getRecordName!: string;

	public data: any = null;

	public addingNewItem: boolean = false;
	public dataSource: any = null;
	public definition: any = null;
	public itemDefinition: any = null;
	public addItemToValue: ((newItem: any) => void) | null = null;
	public updateItemToValue: ((newItem: any) => void) | null = null;

	public dataSourceOptions: any[] = [];
	public selectedItem: any = null;
	public searchField: any = null;

	public searchVisible: boolean = false;
	public searching: boolean = false;

	public otherCases: Case[] = [];

	public dataItem: any = { fields: {} };

	public isValid: boolean = true;
	public canEdit: boolean = true;
	public dirty: boolean = false;
	public showSearch: boolean = true;

	private get showMap () {
		return this.allowMap && this.formColumns.some(c => c.dataType === "map-marker" ||
			c.dataType === "map-path" ||
			c.dataType === "map-region")
	}

	public open (details: any): void {
		this.addingNewItem = details.addItem
		this.dataSource = details.source
		this.definition = details.definition
		this.addItemToValue = details.addItem
		this.updateItemToValue = details.updateItem
		this.otherCases = []

		this.searchVisible = false

		if (!this.definition) {
			this.definition = {
				fields: []
			}
		}

		// Do not check for falsey values - only check if defined
		if (details.showOtherCases !== undefined) {
			this.showOtherCases = details.showOtherCases
		} else {
			this.showOtherCases = true
		}

		// Do not check for falsey values - only check if defined
		if (details.showDataForm !== undefined) {
			this.showDataForm = details.showDataForm
		} else {
			this.showDataForm = true
		}

		if (details.canEdit !== undefined) {
			this.canEdit = details.canEdit
		} else {
			this.canEdit = true
		}

		if (!details.data) {
			this.itemDefinition = null
		}

		this.setDataItem(details.data)

		if (details.autoSearch) {
			this.enableSearch()
		}

		this.$refs.dataDetailsModal.show()
	}

	public async setDataItem (data: any) {
		this.data = data

		if (!data) {
			this.showSearch = false
			this.definition.fields.forEach((field: FieldInstance) => {
				Vue.set(field, "value", null)
				Vue.set(this.dataItem.fields, field.field.id!, null)
			})

			if (this.itemDefinition) {
				this.itemDefinition.fields.forEach((field: FieldInstance) => {
					Vue.set(field, "value", null)
					Vue.set(this.dataItem.fields, field.field.id!, null)
				})
			}

			return
		}
		this.showSearch = true

		this.definition.fields.forEach((field: FieldInstance) => {
			Vue.set(field, "value", data.fields[field.field.id!])
			Vue.set(this.dataItem.fields, field.field.id!, data.fields[field.field.id!])
		})

		if (this.data.definitionId) {
			if (!this.itemDefinition || this.itemDefinition.id !== this.data.definitionId) {
				this.itemDefinition = await api.definitionDetails(this.data.definitionId)
			}
		} else {
			this.itemDefinition = null
		}

		if (this.itemDefinition) {
			this.itemDefinition.fields.forEach((field: FieldInstance) => {
				Vue.set(field, "value", data.fields[field.field.id!])
				Vue.set(this.dataItem.fields, field.field.id!, data.fields[field.field.id!])
			})
		}

		Vue.nextTick().then(() => {
			this.dirty = false
		})
	}

	public close () {
		this.searchField = null
		this.dataItem = { fields: {} }
		this.selectedItem = null
		this.$refs.dataDetailsModal.hide()
	}

	public get dataSourceId (): string | null {
		if (!this.dataSource) {
			return null
		}

		return this.dataSource.id
	}

	@Watch("selectedItem")
	public async onSelectedItemChanges (newItem: any) {
		if (newItem && this.searchVisible) {
			this.otherCases = (await api.dataSourceItemSearchCases("id", newItem.id, true))
				.filter((otherCase: Case) => !this.currentCase || otherCase.id !== this.currentCase.id)
		}

		if (newItem && this.dataSource) {
			let dataSource = this.dataSource
			if (newItem.dataSourceId !== dataSource.id) {

			}
			this.itemDefinition = dataSource.definition
		}
	}

	@Watch("searchField")
	public async searchFieldChanged (field: Field) {
		if (this.searchVisible) {
			if (field && this.dataItem && this.dataItem.fields[field.id!]) {
				const isIdField = field.dataType === "list"
				this.otherCases = (await api.dataSourceItemSearchCases(field.id!, this.dataItem.fields[field.id!], isIdField))
					.filter((otherCase: Case) => !this.currentCase || otherCase.id !== this.currentCase.id)
			} else {
				this.otherCases = []
			}
		}
	}

	public valueChanged (newValue: any) {
		this.dirty = true

		this.definition.fields.forEach((field: FieldInstance) => {
			Vue.set(field, "value", "")
		})

		if (newValue) {
			api.dataSourceGetItem(newValue.id).then((itemData: any) => {
				var fiedsById = this.definition.fields.toDictionaryMap((f: FieldInstance) => f.field.id)
				for (const fieldId in itemData.fields) {
					if (fiedsById[fieldId]) {
						Vue.set(fiedsById[fieldId], "value", itemData.fields[fieldId])
						Vue.set(fiedsById[fieldId], "fromData", true)
					}

					Vue.set(this.dataItem.fields, fieldId, itemData.fields[fieldId])
				}

				if (itemData.dataSourceId && itemData.dataSourceId !== this.dataSource.id) {
					this.definitionGetFromSource(itemData.dataSourceId).then(definition => {
						this.itemDefinition = definition
						Vue.set(this.dataItem, "definitionId", definition.id)
					})
				}
			})
		} else {
			this.dataItem = {}
		}
	}

	public async fetchOptions (search: string, loading: (isLoading: boolean) => void) {
		if (!this.dataSourceId) {
			return
		}

		if (search === "") {
			// this.dataSourceOptions = [];
		} else {
			loading(true)
			this.dataSourceOptions = (await api.dataSourceSearch(this.dataSourceId, null, search)).data
			loading(false)
		}
	}

	public async addItem () {
		if (this.selectedItem) {
			this.dataItem.id = this.selectedItem.id
		} else {
			this.dataItem.id = Guid.newGuid()
			this.dataItem.adhoc = true
		}

		this.dataItem.definitionId = this.itemDefinition ? this.itemDefinition.id : null
		this.dataItem.dataSourceId = this.selectedItem ? this.selectedItem.dataSourceId : null

		if (this.generateItemLabels) {
			this.dataItem.label = await api.dataSourceItemGetLabel(this.definition.id, this.dataItem)
		}

		if (this.addItemToValue) {
			this.addItemToValue(this.dataItem)
		}
		this.close()
	}

	public async updateItem () {
		if (this.updateItemToValue) {
			this.dataItem.id = this.data.id
			this.dataItem.adhoc = this.data.adhoc
			this.dataItem.label = this.data.label
			this.dataItem.definitionId = this.data.definitionId

			if (this.generateItemLabels) {
				this.dataItem.label = await api.dataSourceItemGetLabel(this.definition.id, this.dataItem)
			}

			this.updateItemToValue(this.dataItem)
		}
		this.close()
	}

	public get fields () {
		if (!this.definition) {
			return []
		}

		return this.definition.fields
			.filter((field: FieldInstance) => this.dataItem.fields[field.field.id!])
			.map((field: FieldInstance) => field.field)
	}

	get formColumns () {
		if (!this.definition || !this.definition.fields) {
			return []
		}

		const fields = this.definition.fields
			.sortBy("order")
			.map((field: FieldInstance) => {
				return {
					key: field.field.id,
					label: field.field.title,
					dataType: field.field.dataType,
					dataSourceId: field.field.dataSourceId,
					section: field.section,
					readonly: !!field.field.displayReadOnly,
					errors: (item: any) => !item || !field.requiredRecord || item[field.field.id!] ? null : "Please enter " + field.field.title,
					extensions: field.field.extensions
				}
			})

		const itemFields = (this.itemDefinition
			? this.itemDefinition.fields
				.filter((field: FieldInstance) => !fields.some((fieldColumn: any) => fieldColumn.key === field.field.id))
				.sortBy("order")
				.map((field: FieldInstance) => {
					return {
						key: field.field.id,
						label: field.field.title,
						dataType: field.field.dataType,
						dataSourceId: field.field.dataSourceId,
						section: field.section,
						readonly: false,
						errors: (item: any) => !item || !field.requiredRecord || item[field.field.id!] ? null : "Please enter " + field.field.title,
						extensions: field.field.extensions
					}
				})
			: [])

		return [
			...fields,
			...itemFields
		]
	}

	public get otherCasesColumns (): any[] {
		return [
			{
				key: "caseNumber",
				label: "Case #"
			},
			{
				key: "title"
			},
			{
				key: "areas"
			},
			{
				key: "link",
				label: ""
			}
		]
	}

	public async linkCase (otherCase: Case): Promise<void> {
		if (!this.currentCase) return

		if (this.currentCase.id) {
			try {
				await api.linkCase(this.currentCase.id, otherCase.id!)
				this.displayLinkSuccessToast(otherCase.caseNumber!)
			} catch (e) {
				this.$bvToast.toast("There was an issue linking this case to case " + otherCase.caseNumber + ". Please try again.", {
					title: "Error",
					variant: "danger",
					solid: true,
					autoHideDelay: 5000
				})
			}
		} else {
			// The current case doesn't exist yet
			if (!this.currentCase.links) {
				this.currentCase.links = []
			}

			this.currentCase.links.push({
				caseId: otherCase.id!,
				caseNumber: otherCase.caseNumber!,
				caseTitle: otherCase.title
			})

			this.displayLinkSuccessToast(otherCase.caseNumber!)
		}
	}

	public isLinked (otherCase: Case): boolean {
		if (!this.currentCase) {
			return false
		}
		if (this.currentCase.id === otherCase.id) {
			return true
		}

		return this.currentCase.links.some((linkedCase: any) => linkedCase.caseId === otherCase.id)
	}

	public gotoCase (caseInfo: { id: string, caseNumber: string, title: string }) {
		let routeData = this.$router.resolve({ path: "/cases/" + encodeURIComponent(caseInfo.caseNumber) })
		window.open(routeData.href, "_blank")
	}

	public dataChanged () {
		this.dirty = true
	}

	public async enableSearch () {
		this.searchVisible = true
		this.searching = true
		try {
			if (this.selectedItem) {
				await this.onSelectedItemChanges(this.selectedItem)
			} else if (this.data && !this.data.adhoc) {
				await this.onSelectedItemChanges(this.data)
			} else if (this.searchField) {
				await this.searchFieldChanged(this.searchField)
			}
		} catch (ex) {
			console.error(ex)
			this.searchVisible = false
		}

		this.searching = false
	}

	private modalHidden () {
		if (this.parentMapProvider) {
			this.parentMapProvider.resetMap()
		}
	}

	public displayLinkSuccessToast (otherCaseNumber: string) {
		this.$bvToast.toast("This case has been successfully linked to case " + otherCaseNumber + ".", {
			title: "Case Linked",
			variant: "success",
			solid: true,
			autoHideDelay: 5000
		})
	}
}
